import { render } from "./mgr.vue?vue&type=template&id=caf93a5c&scoped=true"
import script from "./mgr.vue?vue&type=script&lang=js"
export * from "./mgr.vue?vue&type=script&lang=js"

import "./mgr.vue?vue&type=style&index=0&id=caf93a5c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\loong\\develop\\project\\tianyuan\\ty-maintain-web\\ty-maintain-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caf93a5c"]])

export default __exports__